import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IBundleSelectionOptionsData, IBundleSelectionProduct } from '@df/catalog/product/bundle-option-selection';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from '../../catalog/model/product/product.decorator';
import { IfNotTradeStoreDirective } from '../../multisite/trade/if-not-trade-store.directive';
import { IfTradeStoreDirective } from '../../multisite/trade/if-trade-store.directive';
@Component({
    selector: 'basket-bundle-options',
    templateUrl: './basket-bundle-options.component.html',
    standalone: true,
    imports: [ImageModule, IfTradeStoreDirective, TranslationModule, IfNotTradeStoreDirective, PriceComponent, OptionLabelPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketBundleOptionsComponent {
    @Input({
        required: true
    })
    product!: LocalProduct<IProductDataV3>;
    @Input({
        required: true
    })
    selection!: IBundleSelectionOptionsData;
    get bundleOptions(): IBundleSelectionProduct[] {
        return this.product.getBundleSelectedProducts(this.selection) || [];
    }
}
